import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const DeliveryContractor = () => {
  return (
    <SettingsMetaData propertyName={"Delivery_Terms_Contractor"} viewPropertyName={"Delivery Terms"} />
  );
};
export default DeliveryContractor;